import { inject, Injectable } from '@angular/core';
import { ImplementerRegistrationFacadeService } from './implementer-registration-facade.service';
import { filter, from, switchMap, take, tap } from 'rxjs';
import { ImplementerRegistrationFlowStep } from '../models/implement-registration-flow-step';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ImplementerRegistrationFlowService {
  private implementerFacadeService = inject(ImplementerRegistrationFacadeService);
  private router = inject(Router);

  constructor() {}

  navigateToCurrentStep(implementerId: string) {
    return this.implementerFacadeService.implementer$.pipe(
      filter(implementerLoadingState => !!implementerLoadingState.data),
      take(1),
      switchMap(implementerLoadingState => {
        if (!implementerLoadingState.data) {
          throw new Error('Implementer is not loaded');
        }

        const step = implementerLoadingState.data.currentRegistrationFlowStep;
        console.debug('[ImplementerRegistrationFlowService] navigateToCurrentStep: step=', step);

        if (!step && implementerLoadingState.data.isRegistrationComplete) {
          console.debug(
            '[ImplementerRegistrationFlowService] navigateToCurrentStep: Registration is complete, navigating to /implementer-welcome',
          );
          return from(this.router.navigate(['/implementer-welcome']));
        }

        switch (step) {
          case ImplementerRegistrationFlowStep.ContactDetails:
            return from(this.router.navigate(['/implementer', implementerId, 'contact-details']));
          case ImplementerRegistrationFlowStep.Info:
            return from(this.router.navigate(['/implementer', implementerId, 'info']));
          case ImplementerRegistrationFlowStep.Services:
            return from(this.router.navigate(['/implementer', implementerId, 'services']));
          case ImplementerRegistrationFlowStep.Impact:
            return from(this.router.navigate(['/implementer', implementerId, 'impact']));
          case ImplementerRegistrationFlowStep.DocumentUpload:
            return from(this.router.navigate(['/implementer', implementerId, 'document-upload']));
          default:
            throw new Error(`Unknown step: ${step}`);
        }
      }),
    );
  }
}
